import _ from 'underscore';
import GameStarterModel from './game-starter-model';
import launch from './launch';
import { sendOSInfo } from './send-os-info';

var gameStarter = new GameStarterModel();
_.extend(gameStarter, {
  launch: launch,
  sendOSInfo: sendOSInfo
});

export { gameStarter };
